import { LocalizationProvider } from '@/context/useLocalization';
import { ThemeProvider } from '@/context/useTheme';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useEffect, useState } from 'react';
import { FooterProps } from '@/types/global.types';
import { getApiBaseUrl } from '@/utils/utils';

const hiddenHeader = ['/feedback'];
const hiddenFooter = ['/contact-us', '/feedback'];

const Layout = () => {
    const { pathname } = useLocation();
    // Remove language prefix for path checking
    const pathWithoutLang = pathname.replace(/^\/(en|ar)/, '') || '/';
    
    useEffect(() => {
        window.scrollTo({ top: 30 });
    }, [pathname]);

    const [data, setData] = useState<FooterProps>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`${getApiBaseUrl()}/setting`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success && data.data.length > 0) {
                    const settingData = data.data[0];
                    const socialLinks = [
                        { name: 'facebook', link: settingData.facebook },
                        { name: 'twitter', link: settingData.twitter },
                        { name: 'linkedin', link: settingData.linkedin },
                        { name: 'instagram', link: settingData.instagram },
                        { name: 'youtube', link: settingData.youtube },
                        { name: 'whatsapp', link: settingData.whatsapp },
                        { name: 'snapchat', link: settingData.snapchat },
                        { name: 'tiktok', link: settingData.tiktok },
                        { name: 'telegram', link: settingData.telegram },
                    ].filter((item) => item.link);
                    setData({ ...settingData, social: socialLinks });
                }
            })
            .catch((error) => console.error('Error fetching setting:', error))
            .finally(() => setLoading(false));
    }, []);

    return (
        <ThemeProvider>
            <LocalizationProvider>
                <div className="flex flex-col min-h-screen overflow-x-hidden relative">
                    {/* <FilteredEllipse /> */}
                    {hiddenHeader.includes(pathWithoutLang) ? null : <Header data={data} />}
                    <div className="h-full flex-grow">
                        <Outlet />
                    </div>
                    {hiddenFooter.includes(pathWithoutLang) ? null : <Footer data={data} />}
                </div>
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default Layout;
